// extracted by mini-css-extract-plugin
export default {"dashboard":"PersonalTasksPage_dashboard__U37Lf"};